import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

const CLASS_NAME = 'SH-c-admin-reports';

class AdminReportsController extends Controller {
  @service constants;
  @service store;

  get className() {
    return CLASS_NAME;
  }

  @task
  *loadReports() {
    const reports = yield this.store.findAll('report');

    this.set('model.reports', reports);
  }
}

export default AdminReportsController;
